import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Accessibility, Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsLevelMovePending } from 'store/cms/models';

@Component({
    selector: 'xm-level-move-pending',
    templateUrl: './pending.html',
    styleUrls: ['./pending.scss'],
    standalone: false
})
export class XmLevelMovePending implements OnInit, OnDestroy {
    public pageData: CmsLevelMovePending;
    public logoIcon: MediaImageOptions;
    public emailIcon: MediaImageOptions;

    private xmStore: XmStore;
    private accessibility: Accessibility;
    private state: StateService;
    private subscriptions: Subscription[] = [];

    constructor(accessibility: Accessibility, state: StateService, xmStore: XmStore) {
        Object.assign(this, { accessibility, state, xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLevelMovePending>(CmsLevelMovePending), (result: CmsLevelMovePending) => {
            this.pageData = result;
            this.logoIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.fiveGIcon)
            };
            this.emailIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.envelopeIcon)
            };
        }));

        this.accessibility.focusHash('pending-head');
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public endLevelMoveFlow(): void {
        this.state.go('account.activity.landing');
    }
}
